import { useState, useMemo } from "react";

const allCities = [
  { name: "Richmond", tagline: "Capital region expedited passport services", highlights:["Downtown & West End coverage", "Serving Henrico, Chesterfield, Hanover"], badge: "Most Popular", status: "live", route: "/richmond-va" },
  { name: "Arlington", tagline: "Northern Virginia expedited passport processing", highlights:["DC metro corridor coverage", "Serving Pentagon City, Crystal City"], badge: "Most Popular", status: "live", route: "/arlington-va" },
  { name: "Alexandria", tagline: "Historic Virginia expedited passport services", highlights:["Old Town & Del Ray coverage", "Serving Mount Vernon, Fort Hunt"], badge: "Most Popular", status: "live", route: "/alexandria-va" },
  { name: "Virginia Beach", tagline: "Coastal Virginia expedited passport hub", highlights:["Oceanfront & Town Center coverage", "Serving Norfolk, Chesapeake"], badge: "Most Popular", status: "live", route: "/virginia-beach" },
  { name: "Norfolk", tagline: "Hampton Roads expedited passport processing", highlights:["Naval Station area coverage", "Serving Virginia Beach, Chesapeake"], badge: "Most Popular", status: "live", route: "/norfolk-va" },
  { name: "Chesapeake", tagline: "South Hampton Roads expedited passport services", highlights:["Chesapeake area coverage", "Serving Virginia Beach, Norfolk"], badge: "Most Popular", status: "live", route: "/chesapeake-va" },
  { name: "Newport News", tagline: "Peninsula expedited passport processing", highlights:["Newport News area coverage", "Serving Hampton, Williamsburg"], badge: "Most Popular", status: "live", route: "/newport-news-va" },
  { name: "Charlottesville", tagline: "Central Virginia expedited passport services", highlights:["UVA area coverage", "Serving Albemarle, Greene County"], badge: "Most Popular", status: "live", route: "/charlottesville-va" },
  { name: "Roanoke", tagline: "Southwest Virginia expedited passport hub", highlights:["Roanoke Valley coverage", "Serving Salem, Vinton, Blacksburg"], badge: "Most Popular", status: "live", route: "/roanoke-va" },
  { name: "Fredericksburg", tagline: "Rappahannock region expedited passport services", highlights:["Fredericksburg area coverage", "Serving Spotsylvania, Stafford"], badge: "Most Popular", status: "live", route: "/fredericksburg-va" },
  { name: "Williamsburg", tagline: "Historic Triangle expedited passport processing", highlights:["Colonial Williamsburg area", "Serving James City, York County"], badge: "Most Popular", status: "live", route: "/williamsburg-va" },
  { name: "McLean", tagline: "Fairfax County expedited passport services", highlights:["Tysons Corner area coverage", "Serving Great Falls, Vienna"], badge: "Most Popular", status: "live", route: "/mclean-va" },
  { name: "Falls Church", tagline: "Independent city expedited passport processing", highlights:["Falls Church area coverage", "Serving Arlington, Fairfax"], badge: "Most Popular", status: "live", route: "/falls-church-va" },
  { name: "Fairfax", tagline: "Fairfax County expedited passport services", highlights:["Fairfax City area coverage", "Serving Fairfax County, Vienna"], badge: "Most Popular", status: "live", route: "/fairfax-va" },
  { name: "Vienna", tagline: "Northern Virginia expedited passport processing", highlights:["Vienna area coverage", "Serving Fairfax, McLean, Tysons"], badge: "Most Popular", status: "live", route: "/vienna-va" },
  { name: "Reston", tagline: "Dulles corridor expedited passport services", highlights:["Reston area coverage", "Serving Herndon, Dulles Airport"], badge: "Most Popular", status: "live", route: "/reston-va" },
  { name: "Herndon", tagline: "Dulles corridor expedited passport processing", highlights:["Herndon area coverage", "Serving Reston, Sterling"], badge: "Most Popular", status: "live", route: "/herndon-va" },
  { name: "Tysons", tagline: "Business district expedited passport services", highlights:["Tysons Corner coverage", "Serving McLean, Vienna"], badge: "Most Popular", status: "live", route: "/tysons-va" },
  { name: "Leesburg", tagline: "Loudoun County expedited passport processing", highlights:["Leesburg area coverage", "Serving Ashburn, Sterling"], badge: "Most Popular", status: "live", route: "/leesburg-va" },
  { name: "Ashburn", tagline: "Loudoun County expedited passport services", highlights:["Ashburn area coverage", "Serving Leesburg, Sterling"], badge: "Most Popular", status: "live", route: "/ashburn-va" },
  { name: "Woodbridge", tagline: "Prince William County expedited passport processing", highlights:["Woodbridge area coverage", "Serving Dale City, Lake Ridge"], badge: "Most Popular", status: "live", route: "/woodbridge-va" },
  { name: "Springfield", tagline: "Fairfax County expedited passport services", highlights:["Springfield area coverage", "Serving Burke, Lorton"], badge: "Most Popular", status: "live", route: "/springfield-va" },
  { name: "Burke", tagline: "Fairfax County expedited passport processing", highlights:["Burke area coverage", "Serving Springfield, Fairfax Station"], badge: "Most Popular", status: "live", route: "/burke-va" },
  { name: "Centreville", tagline: "Fairfax County expedited passport services", highlights:["Centreville area coverage", "Serving Chantilly, Clifton"], badge: "Most Popular", status: "live", route: "/centreville-va" },
  { name: "Manassas", tagline: "Prince William County expedited passport processing", highlights:["Manassas area coverage", "Serving Manassas Park, Bristow"], badge: "Most Popular", status: "live", route: "/manassas-va" },
  { name: "Winchester", tagline: "Shenandoah Valley expedited passport services", highlights:["Frederick County coverage", "Serving Martinsburg WV, Front Royal"], badge: "Most Popular", status: "live", route: "/winchester-va" },
  { name: "Harrisonburg", tagline: "Shenandoah Valley expedited passport processing", highlights:["Harrisonburg area coverage", "Serving Rockingham County, JMU"], badge: "Most Popular", status: "live", route: "/harrisonburg-va" },
  { name: "Lynchburg", tagline: "Central Virginia expedited passport services", highlights:["Lynchburg area coverage", "Serving Campbell County, Liberty U"], badge: "Most Popular", status: "live", route: "/lynchburg-va" },
  { name: "Blacksburg", tagline: "New River Valley expedited passport processing", highlights:["Blacksburg area coverage", "Serving Christiansburg, Virginia Tech"], badge: "Most Popular", status: "live", route: "/blacksburg-va" },
  { name: "Danville", tagline: "Southside Virginia expedited passport services", highlights:["Danville area coverage", "Serving Pittsylvania County"], badge: "Most Popular", status: "live", route: "/danville-va" },
  { name: "Petersburg", tagline: "Tri-Cities expedited passport processing", highlights:["Petersburg area coverage", "Serving Colonial Heights, Hopewell"], badge: "Most Popular", status: "live", route: "/petersburg-va" },
  { name: "Colonial Heights", tagline: "Tri-Cities expedited passport services", highlights:["Colonial Heights area coverage", "Serving Petersburg, Fort Lee"], badge: "Most Popular", status: "live", route: "/colonial-heights-va" },
  { name: "Hopewell", tagline: "Tri-Cities expedited passport processing", highlights:["Hopewell area coverage", "Serving Petersburg, Colonial Heights"], badge: "Most Popular", status: "live", route: "/hopewell-va" },
  { name: "Suffolk", tagline: "Western Hampton Roads expedited passport services", highlights:["Suffolk area coverage", "Serving Chesapeake, Isle of Wight"], badge: "Most Popular", status: "live", route: "/suffolk-va" },
  { name: "Portsmouth", tagline: "Hampton Roads expedited passport processing", highlights:["Portsmouth area coverage", "Serving Norfolk, Chesapeake"], badge: "Most Popular", status: "live", route: "/portsmouth-va" },
  { name: "Hampton", tagline: "Virginia Peninsula expedited passport services", highlights:["Hampton area coverage", "Serving Newport News, Langley AFB"], badge: "Most Popular", status: "live", route: "/hampton-va" },
  { name: "Chester", tagline: "Chesterfield County expedited passport processing", highlights:["Chester area coverage", "Serving Richmond, Colonial Heights"], badge: "Most Popular", status: "live", route: "/chester-va" },
  { name: "Glen Allen", tagline: "Henrico County expedited passport services", highlights:["Glen Allen area coverage", "Serving Short Pump, Richmond"], badge: "Most Popular", status: "live", route: "/glen-allen-va" },
  { name: "Midlothian", tagline: "Chesterfield County expedited passport processing", highlights:["Midlothian area coverage", "Serving Richmond, Chesterfield"], badge: "Most Popular", status: "live", route: "/midlothian-va" },
  { name: "Mechanicsville", tagline: "Hanover County expedited passport services", highlights:["Mechanicsville area coverage", "Serving Richmond, Ashland"], badge: "Most Popular", status: "live", route: "/mechanicsville-va" },
  { name: "Short Pump", tagline: "Western Henrico expedited passport processing", highlights:["Short Pump area coverage", "Serving Glen Allen, Richmond"], badge: "Most Popular", status: "live", route: "/short-pump-va" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function VACitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            Virginia Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your Virginia Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">"{searchQuery}"</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">Virginia</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We are always adding new Virginia locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}